"use strict"; // @ts-ignore

__webpack_public_path__ = window.publicPath;